var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommend-container"},[_c('Slide',{attrs:{"dataList":_vm.slideData,"appid":_vm.appid,"servicePageData":_vm.servicePageData,"userGuideFeature":_vm.userGuideFeature}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }